module.exports = __webpack_public_path__ + "media/use_cases/slider-portrait-1-20de4113.png";